module.exports = __webpack_public_path__ + "static/media/logo.f2f4fb9b.png";